import { Flex, Text } from '@chakra-ui/react';
import { NODE_HEIGHT_PX } from '@features/create/constants';
import { Handle, NodeProps, Position } from '@xyflow/react';
import { toPxString } from 'helpers/styles';
import { memo } from 'react';

interface RootNodeProps extends NodeProps {
  data: { label?: string };
}
const RootNode: React.FC<RootNodeProps> = ({ data }) => {
  return (
    <Flex align="center" h={toPxString(NODE_HEIGHT_PX)}>
      <Text fontWeight="medium">{data?.label ?? 'Basket of needs'}</Text>
      <Handle type="source" position={Position.Bottom} style={{ visibility: 'hidden', left: 16 }} />
    </Flex>
  );
};

export default memo(RootNode);
